export enum ActionTypeKeys {
    SHOW = 'GLOBAL_NOTIFICATION_SHOW',
    CLEAR = 'GLOBAL_NOTIFICATION_CLEAR',
}